import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { Header, Footer } from "~/components/blocks";
import { HeroBanner, LegalInformationContent } from "~/components/sections";
import { Breadcrumb } from "~/components/elements";

export default function LegalInformation() {
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },
    {
      text: "Informações legais",
      link: "/informacoes-legais",
    },
  ];

  // useEffect(() => {
  //   scrollTo(700);
  // }, []);

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Informações legais</title>
      </Helmet>
      <Header />
      <HeroBanner />
      <div id="conteudo"></div>
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <Breadcrumb navBreadcrumb={navBreadcrumb} />
        <LegalInformationContent />
      </motion.div>
      <Footer />
    </>
  );
}
